import { render } from "./QRCodePopup.vue?vue&type=template&id=2d808ce2"
import script from "./QRCodePopup.vue?vue&type=script&lang=js"
export * from "./QRCodePopup.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__